import { ConfigApp } from "../configApp";
import { IAuthenticator } from "./interfaces/IAuthenticator";
import { MsalAuthenticator } from "./msalAuthenticator";

export class CanApiAuthenticator extends MsalAuthenticator implements IAuthenticator {
  public async authenticateRequestAsync(request: RequestInit): Promise<RequestInit> {
    const accessToken = await this.acquireTokenAsync(ConfigApp.scopes.canApi);
    request.headers = { ...request.headers, Authorization: `Bearer ${accessToken}` };
    return request;
  }
}
